export default __webpack_public_path__ + "static/media/logo-us-Abercrombie.7026fa3f.svg";